// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_b_2_b_mini_bob_mfe_styles" + "." + "6a806c2a" + ".chunk.css";
};